// import React, { useEffect, useState } from 'react';

// import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';
// import { Contact } from '../../../types/crm-contact';
// import { FormTextbox, FormPhotoUploader } from '../..';
// import { EmailRule } from 'devextreme-react/validator';
// import { getSizeQualifier } from '../../../utils/media-query';
// import SelectBox from 'devextreme-react/select-box';

// export const ContactNewForm = ({ initData, onDataChanged }: { initData: Contact, onDataChanged: (data) => void }) => {
//   const [newContactData, setNewContactData] = useState<Contact>({ ...initData });

//   useEffect(() => {
//     setNewContactData({ ...initData });
//   }, [initData]);

//   const updateField = (field: string) => (value) => {
//     const newData = { ...newContactData, ...{ [field]: value } };

//     onDataChanged(newData);
//     setNewContactData(newData);
//   };

//   return (
//     <Form
//       className='plain-styled-form'
//       screenByWidth={getSizeQualifier}
//     >
//       <GroupItem>
//         <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
//         <FormItem>
//           <FormPhotoUploader />
//         </FormItem>
//       </GroupItem>

//       <GroupItem>
//         <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
//         <FormItem>
//           <FormTextbox
//             label='First Name'
//             value={newContactData.firstName}
//             isEditing={false}
//             onValueChange={updateField('firstName')}
//           />
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             label='Last Name'
//             value={newContactData.lastName}
//             isEditing={false}
//             onValueChange={updateField('lastName')}
//           />
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             label='Company'
//             value={newContactData.company}
//             isEditing={false}
//             onValueChange={updateField('company')}
//           />
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             label='Position'
//             value={newContactData.position}
//             isEditing={false}
//             onValueChange={updateField('position')}
//           />
//         </FormItem>
//       </GroupItem>

//       <GroupItem cssClass='contact-fields-group'>
//         <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
//         <FormItem>
//           <FormTextbox
//             value={newContactData.manager}
//             label='Assigned to'
//             isEditing={false}
//             onValueChange={updateField('manager')}
//           />
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             value={newContactData.phone}
//             isEditing={false}
//             onValueChange={updateField('phone')}
//             icon='tel'
//             label='Phone'
//             mask='(000) 000-0000'
//           />
//         </FormItem>
//         <FormItem>
//           <SelectBox
//             value={newContactData.manager}
//             label='Assigned to'
//             // isEditing={false}
//             onValueChange={updateField('manager')}
//           />
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             value={newContactData.email}
//             onValueChange={updateField('email')}
//             isEditing={false}
//             label='Email'
//             icon='email'
//           >
//             <EmailRule />
//           </FormTextbox>
//         </FormItem>
//         <FormItem>
//           <FormTextbox
//             value={newContactData.address}
//             isEditing={false}
//             onValueChange={updateField('address')}
//             icon='home'
//             label='Address'
//           />
//         </FormItem>
//       </GroupItem>
//     </Form>
//   );
// };

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// import Form, {
//   Item as FormItem,
//   GroupItem,
//   ColCountByScreen,
// } from 'devextreme-react/form';

// import SelectBox from 'devextreme-react/select-box';
// import TextArea from 'devextreme-react/text-area';

// import { Contact } from '../../../types/crm-contact';
// import { getSizeQualifier } from '../../../utils/media-query';

// type NoiDung = {
//   ID: number;
//   NOI_DUNG_KIEM_TRA: string;
//   PHUONG_PHAP_KIEM_TRA: string;
//   TIEU_CHUAN: string;
// };

// export const ContactNewForm = ({
//   initData,
//   onDataChanged,
// }: {
//   initData: Contact;
//   onDataChanged: (data) => void;
// }) => {
//   const [newContactData, setNewContactData] = useState<Contact>({ ...initData });

//   const [thietBiList, setThietBiList] = useState([]);
//   const [boPhanList, setBoPhanList] = useState([]);
//   const [noiDungList, setNoiDungList] = useState<NoiDung[]>([]);

//   const [capTuanTra, setCapTuanTra] = useState<number | null>(null);
//   const [ca, setCa] = useState<number | null>(null);
//   const [trangThai, setTrangThai] = useState<number | null>(null);

//   const [, setAnh] = useState<File | null>(null);
//   const [deXuat, setDeXuat] = useState('');

//   //////////////////////////////////////
//   // Load thiết bị
//   //////////////////////////////////////
//   useEffect(() => {
//     axios.get('http://localhost:5000/api/thietbi').then((res) => {
//       setThietBiList(res.data);
//     });
//   }, []);

//   useEffect(() => {
//     setNewContactData({ ...initData });
//   }, [initData]);

//   //////////////////////////////////////
//   // Update field
//   //////////////////////////////////////
//   const updateField = (field: string) => (value: any) => {
//     const newData = { ...newContactData, [field]: value };

//     setNewContactData(newData);
//     onDataChanged(newData);
//   };

//   //////////////////////////////////////
//   // Chọn thiết bị
//   //////////////////////////////////////
//   const handleThietBi = (value: number) => {
//     updateField('THIET_BI')(value);

//     axios.get(`http://localhost:5000/api/bophan/${value}`).then((res) => {
//       setBoPhanList(res.data);
//       setNoiDungList([]);
//     });
//   };

//   //////////////////////////////////////
//   // Chọn bộ phận
//   //////////////////////////////////////
//   const handleBoPhan = (value: number) => {
//     updateField('BO_PHAN')(value);

//     axios.get(`http://localhost:5000/api/noidung/${value}`).then((res) => {
//       setNoiDungList(res.data);
//     });
//   };

//   //////////////////////////////////////
//   // Dropdown data
//   //////////////////////////////////////
//   const capTuanTraList = [
//     { id: 1, name: 'Tuần tra cấp 1' },
//     { id: 2, name: 'Tuần tra cấp 2' },
//     { id: 3, name: 'Tuần tra cấp 3' },
//   ];

//   const caList = [
//     { id: 1, name: 'Ca 1' },
//     { id: 2, name: 'Ca 2' },
//     { id: 3, name: 'Ca 3' },
//   ];

//   const trangThaiList = [
//     { id: 1, name: 'OK' },
//     { id: 2, name: 'Not OK' },
//   ];

//   return (
//     <Form className='plain-styled-form' screenByWidth={getSizeQualifier}>
//       {/* Thiết bị + Bộ phận */}

//       <GroupItem>
//         <ColCountByScreen xs={1} sm={2} md={2} lg={2} />

//         <FormItem label={{ text: 'Thiết bị' }}>
//           <SelectBox
//             dataSource={thietBiList}
//             displayExpr='TEN_THIET_BI'
//             valueExpr='ID'
//             value={newContactData.THIET_BI}
//             onValueChanged={(e) => handleThietBi(e.value)}
//           />
//         </FormItem>

//         <FormItem label={{ text: 'Bộ phận' }}>
//           <SelectBox
//             dataSource={boPhanList}
//             displayExpr='TEN_BO_PHAN'
//             valueExpr='ID'
//             value={newContactData.BO_PHAN}
//             onValueChanged={(e) => handleBoPhan(e.value)}
//           />
//         </FormItem>
//       </GroupItem>

//       {/* Nội dung kiểm tra */}

//       <GroupItem>
//         <ColCountByScreen xs={1} sm={1} md={1} lg={1} />

//         <FormItem label={{ text: 'Nội dung kiểm tra' }}>
//           <div>
//             {noiDungList.map((i) => (
//               <div key={i.ID} style={{ marginBottom: 10 }}>
//                 <b>Nội dung:</b> {i.NOI_DUNG_KIEM_TRA}
//                 <br />

//                 <b>Phương pháp:</b> {i.PHUONG_PHAP_KIEM_TRA}
//                 <br />

//                 <b>Tiêu chuẩn:</b> {i.TIEU_CHUAN}
//               </div>
//             ))}
//           </div>
//         </FormItem>
//       </GroupItem>

//       {/* Cấp tuần tra + Ca + Trạng thái */}

//       <GroupItem>
//         <ColCountByScreen xs={1} sm={3} md={3} lg={3} />

//         <FormItem label={{ text: 'Cấp tuần tra' }}>
//           <SelectBox
//             dataSource={capTuanTraList}
//             displayExpr='name'
//             valueExpr='id'
//             value={capTuanTra}
//             onValueChanged={(e) => setCapTuanTra(e.value)}
//           />
//         </FormItem>

//         <FormItem label={{ text: 'Ca' }}>
//           <SelectBox
//             dataSource={caList}
//             displayExpr='name'
//             valueExpr='id'
//             value={ca}
//             onValueChanged={(e) => setCa(e.value)}
//           />
//         </FormItem>

//         <FormItem label={{ text: 'Trạng thái' }}>
//           <SelectBox
//             dataSource={trangThaiList}
//             displayExpr='name'
//             valueExpr='id'
//             value={trangThai}
//             onValueChanged={(e) => setTrangThai(e.value)}
//           />
//         </FormItem>
//       </GroupItem>

//       {/* Nếu Not OK */}

//       {trangThai === 2 && (
//         <GroupItem>
//           <ColCountByScreen xs={1} sm={1} md={1} lg={1} />

//           <FormItem label={{ text: 'Upload / Chụp ảnh' }}>
//             <input
//               type='file'
//               accept='image/*'
//               capture='environment'
//               onChange={(e) => {
//                 if (e.target.files) {
//                   setAnh(e.target.files[0]);
//                 }
//               }}
//             />
//           </FormItem>

//           <FormItem label={{ text: 'Đề xuất sửa chữa' }}>
//             <TextArea
//               height={90}
//               value={deXuat}
//               onValueChanged={(e) => setDeXuat(e.value)}
//             />
//           </FormItem>
//         </GroupItem>
//       )}
//     </Form>
//   );
// };

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Form, {
  Item as FormItem,
  GroupItem,
  ColCountByScreen,
} from 'devextreme-react/form';
import { Device } from '../../../types/crm-contact';
import { FormTextbox, FormPhotoUploader } from '../..';
// import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import SelectBox from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import {nameserver} from "../../../config/nameServer"
type NoiDung = {
  ID: number;
  NOI_DUNG_KIEM_TRA: string;
  PHUONG_PHAP_KIEM_TRA: string;
  TIEU_CHUAN: string;
};
export const ContactNewForm = ({
  initData,
  onDataChanged,
}: {
  initData: Device;
  onDataChanged: (data) => void;
}) => {
  const [newContactData, setNewContactData] = useState<Device>({ ...initData });
  const [thietBi, setThietBiList] = useState([]);
  const [boPhan, setBoPhanList] = useState([]);
  const [noiDungList, setNoiDungList] = useState<NoiDung[]>([]);

  const [capTuanTra, setCapTuanTra] = useState<number | null>(null);
  const [ca, setCa] = useState<number | null>(null);
  const [trangThai, setTrangThai] = useState<number | null>(null);
  // const [deXuat,setDeXuat] = useState('');

  // const [, setAnh] = useState<File | null>(null);
  const [deXuat, setDeXuat] = useState('');
  useEffect(() => {
    setNewContactData({ ...initData });
    setNoiDungList([]);
    setCapTuanTra(null);
    setCa(null);
    setTrangThai(null);
    setDeXuat('');
  }, [initData]);
  useEffect(() => {
    axios.get(`${nameserver}/api/thietbi`).then((res) => {
      setThietBiList(res.data);
    });
  }, []);
  const updateField = (field: string) => (value) => {
    const newData = { ...newContactData, ...{ [field]: value } };
    onDataChanged(newData);
    setNewContactData(newData);
  };
  const handleThietBi = (value: number) => {
    const newData = {
      ...newContactData,
      THIET_BI: value,
      BO_PHAN: null,
    };

    setNewContactData(newData);
    onDataChanged(newData);
    console.log(value);
    axios.get(`${nameserver}/api/bophan/${value}`).then((res) => {
      setBoPhanList(res.data);
      setNoiDungList([]);
      console.log(res.data);
    });
  };
  const handleBoPhan = (value: number) => {
    const id = Number(value); // ép về number

    updateField('BO_PHAN')(id);

    axios.get(`${nameserver}/api/noidung/${id}`).then((res) => {
      setNoiDungList(res.data);

      const item = res.data[0];

      const newData = {
        ...newContactData,
        BO_PHAN: id,
        NOI_DUNG_KIEM_TRA: item?.NOI_DUNG_KIEM_TRA || '',
        PHUONG_PHAP_KIEM_TRA: item?.PHUONG_PHAP_KIEM_TRA || '',
        TIEU_CHUAN: item?.TIEU_CHUAN || '',
      };

      setNewContactData(newData);
      onDataChanged(newData);
    });
  };

  const capTuanTraList = [
    { id: 1, name: 'Tuần tra cấp 1' },
    { id: 2, name: 'Tuần tra cấp 2' },
    { id: 3, name: 'Tuần tra cấp 3' },
  ];

  const caList = [
    { id: 1, name: 'Ca 1' },
    { id: 2, name: 'Ca 2' },
    { id: 3, name: 'Ca 3' },
  ];

  const trangThaiList = [
    { id: 1, name: 'OK' },
    { id: 2, name: 'Not OK' },
  ];
  return (
    <Form className='plain-styled-form' screenByWidth={getSizeQualifier}>
      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem label={{ text: 'Thiết bị' }}>
          <SelectBox
            dataSource={thietBi}
            displayExpr='TEN_THIET_BI'
            valueExpr='ID'
            value={newContactData.THIET_BI}
            onValueChanged={(e) => handleThietBi(e.value)}
          />
        </FormItem>

        <FormItem label={{ text: 'Bộ phân' }}>
          <SelectBox
            dataSource={boPhan}
            displayExpr='TEN_BO_PHAN'
            valueExpr='ID'
            value={newContactData.BO_PHAN || null}
            onValueChanged={(e) => handleBoPhan(e.value)}
          />
        </FormItem>
      </GroupItem>

      {/* <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />

        {(noiDungList.length > 0 ? noiDungList : [{}]).map((i, index) => (
          <React.Fragment key={index}>
            <FormItem>
              <FormTextbox
                label='Nội dung kiểm tra'
                value={i?.NOI_DUNG_KIEM_TRA || ' '}
                isEditing={false}
                onValueChange={() => null}
              />
            </FormItem>

            <FormItem>
              <FormTextbox
                label='Phương pháp kiểm tra'
                value={i?.PHUONG_PHAP_KIEM_TRA || ' '}
                isEditing={false}
                onValueChange={() => null}
              />
            </FormItem>

            <FormItem>
              <FormTextbox
                label='Tiêu chuẩn'
                value={i?.TIEU_CHUAN || ' '}
                isEditing={false}
                onValueChange={() => null}
              />
            </FormItem>
          </React.Fragment>
        ))}
      </GroupItem> */}
      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />

        <FormItem isRequired={false}>
          <FormTextbox
            label='Nội dung kiểm tra'
            value={noiDungList[0]?.NOI_DUNG_KIEM_TRA || ''}
            isEditing={false}
            onValueChange={() => null}
          />
        </FormItem>

        <FormItem isRequired={false}>
          <FormTextbox
            label='Phương pháp kiểm tra'
            value={noiDungList[0]?.PHUONG_PHAP_KIEM_TRA || ''}
            isEditing={false}
            onValueChange={() => null}
          />
        </FormItem>

        <FormItem isRequired={false}>
          <FormTextbox
            label='Tiêu chuẩn'
            value={noiDungList[0]?.TIEU_CHUAN || ''}
            isEditing={false}
            onValueChange={() => null}
          />
        </FormItem>
      </GroupItem>
      <GroupItem>
        <ColCountByScreen xs={1} sm={3} md={3} lg={3} />

        <FormItem label={{ text: 'Cấp tuần tra' }}>
          <SelectBox
            dataSource={capTuanTraList}
            displayExpr='name'
            valueExpr='id'
            value={capTuanTra}
            onValueChanged={(e) => {
              setCapTuanTra(e.value);

              const newData = {
                ...newContactData,
                CAP_TUAN_TRA: e.value,
              };
              setNewContactData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>

        <FormItem label={{ text: 'Ca' }}>
          <SelectBox
            dataSource={caList}
            displayExpr='name'
            valueExpr='id'
            value={ca}
            onValueChanged={(e) => {
              setCa(e.value);

              const newData = {
                ...newContactData,
                CA: e.value,
              };
              setNewContactData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>

        <FormItem label={{ text: 'Trạng thái' }}>
          <SelectBox
            dataSource={trangThaiList}
            displayExpr='name'
            valueExpr='id'
            value={trangThai}
            onValueChanged={(e) => {
              setTrangThai(e.value);

              const newData = {
                ...newContactData,
                TRANG_THAI: e.component.option('selectedItem').name,
              };

              setNewContactData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>
      </GroupItem>

      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
        <FormItem>
          <FormPhotoUploader
            onUploaded={(url) => {
              const newData = {
                ...newContactData,
                ANH: url,
              };

              setNewContactData(newData);
              onDataChanged(newData);
            }}
          />
          {newContactData?.ANH && (
            <div style={{ marginTop: 10 }}>
              <img
                src={newContactData.ANH}
                alt='preview'
                style={{ width: 200, borderRadius: 8 }}
              />
            </div>
          )}
        </FormItem>

        <FormItem label={{ text: 'Đề xuất sửa chữa' }}>
          <TextArea
            height={90}
            value={deXuat}
            onValueChanged={(e) => {
              setDeXuat(e.value);
              const newData = {
                ...newContactData,
                DE_XUAT: e.value,
              };
              setNewContactData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>
      </GroupItem>
    </Form>
  );
};
